import { GQLSimpleCtaFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { ButtonSize, OutlineLinkButton, SmallArrowIcon } from '@theprintbar/ui';
import { CTAContainer } from './CTAContainer';
import { CTAText } from './CTAText';

interface CTAProps {
	content: Pick<GQLSimpleCtaFragment, 'simpleCTA'>;
	containerClassName?: string;
	boxClassName?: string;
	boxBackground?: string;
	headerClassName?: string;
}

export function SimpleCTA({ content, containerClassName, boxClassName, boxBackground, headerClassName }: CTAProps) {
	if (!content?.simpleCTA?.structure) return null;

	const { title, text, link, icon, colour } = content.simpleCTA.structure;

	return (
		<CTAContainer className={containerClassName}>
			<div className={cn('w-full')}>
				{/* CTA Container */}
				<div
					className={cn('rounded-3xl border border-blue p-10 lg:px-12 2xl:pr-36 lg:py-16', boxClassName)}
					style={{ backgroundColor: !!boxBackground ? boxBackground : colour || undefined }}
				>
					{/* Content */}
					<div className={cn('space-y-10')}>
						<h2 className={cn('font-display text-2xl font-light lg:text-3xl', headerClassName)}>{title}</h2>
						<CTAText className="lg:text-base text-sm" text={text} />
						{link ? (
							<OutlineLinkButton
								className="w-fit uppercase font-belfast !font-bold text-xs"
								to={link.to || '#'}
								icon={SmallArrowIcon}
								iconSize={ButtonSize.S}
							>
								{link.text}
							</OutlineLinkButton>
						) : null}
						{icon && <div />}
					</div>
					{/* Icon */}
				</div>
			</div>
		</CTAContainer>
	);
}
